<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Tools</h5>
      <b-row>
        <b-col md="12">
          <b-row class="mt-4">
            <b-col md="2" class="my-1">
              <b-input-group>
                <b-input-group-text
                  class="bg-white border-right-0"
                  slot="prepend"
                >
                  <img src="@/assets/filter.svg" alt />
                </b-input-group-text>
                <b-dropdown
                  text="Filter Data"
                  variant="light"
                  toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
                  slot="append"
                >
                  <div class="p-3">
                    <b-row>
                      <b-col md="6">
                        <b-form-group
                          id="fieldset-1"
                          label="Title"
                          class="font-weight-bold"
                          label-for="input-1"
                        >
                          <input
                            placeholder="Title"
                            v-model="title"
                            name="title"
                            type="text"
                            data-vv-as="Title"
                            class="form-control"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6">
                        <b-form-group
                          id="fieldset-1"
                          label="Member Type"
                          class="font-weight-bold"
                          label-for="input-1"
                        >
                          <b-form-select
                            v-model="membership_type"
                            name="membership_type"
                            data-vv-as="Member Type"
                            class="mb-3"
                          >
                            <template v-slot:first>
                              <option value disabled>-- Member Type --</option>
                            </template>
                            <option value="gold">Gold</option>
                            <option value="silver">Silver</option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group
                          id="fieldset-1"
                          label="Benefit Type"
                          class="font-weight-bold"
                          label-for="input-1"
                        >
                          <b-form-select
                            v-model="posm_type"
                            name="posm_type"
                            data-vv-as="Benefit Type"
                            class="mb-3"
                          >
                            <template v-slot:first>
                              <option value disabled>-- Benefit Type --</option>
                            </template>
                            <option value="Fasilitas foto produk gratis">
                              Fasilitas foto produk gratis
                            </option>
                            <option value="Exclusive welcome kit">
                              Exclusive welcome kit
                            </option>
                            <option value="Menjadi merchant PaxelMarket">
                              Menjadi merchant PaxelMarket
                            </option>
                            <option value="Join events #AntarkanKebaikan">
                              Join events #AntarkanKebaikan
                            </option>
                            <option value="Exclusive video 1 menit gratis">
                              Exclusive video 1 menit gratis
                            </option>
                            <option value="Produk dipost influencer 1x">
                              Produk dipost influencer 1x
                            </option>
                            <option value="Hero khusus untuk bisnismu">
                              Hero khusus untuk bisnismu
                            </option>
                            <option value="Harga spesial peralatan bisnis">
                              Harga spesial peralatan bisnis
                            </option>
                            <option value="Diskon packaging material">
                              Diskon packaging material
                            </option>
                            <option value="Harga spesial bahan baku">
                              Harga spesial bahan baku
                            </option>
                            <option value="Asuransi kesehatan">
                              Asuransi kesehatan
                            </option>
                            <option value="Asisten pribadi khusus">
                              Asisten pribadi khusus
                            </option>
                            <option value="Fasilitas paska bayar">
                              Fasilitas paska bayar
                            </option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <br />
                    <b-row style="text-align-last: right">
                      <b-col>
                        <b-button
                          variant="outline-secondary"
                          @click="resetSearch()"
                          class="mr-3"
                          >Set Ulang</b-button
                        >
                        <b-button variant="primary" @click="search()"
                          >Cari</b-button
                        >
                      </b-col>
                    </b-row>
                  </div>
                  <b-dropdown-item
                    class="pointer-off"
                    style="width: 450px"
                  ></b-dropdown-item>
                </b-dropdown>
              </b-input-group>
            </b-col>
            <b-col md="2" class="my-1" align="right">
              <b-form inline>
                Show &nbsp;
                <b-form-select
                  v-model="perPage"
                  :options="pageOptions"
                ></b-form-select>
                &nbsp; Records
              </b-form>
            </b-col>
            <b-col md="5" class="my-1"></b-col>
            <b-col md="3" class="my-1" align="right">
              <!-- <b-button class="btn btn-warning px-4" style="padding-top:6px;padding-bottom:6px" :disabled="loadingCSV" @click="downloadCSV()">
                  <b-spinner label="Spinning" v-show="loadingCSV"></b-spinner> <i class="fas fa-file-download" style="font-size:16px"></i> &nbsp; Export to CSV
                </b-button> -->
              <router-link :to="{ name: 'createPointSales' }">
                <b-button variant="primary">
                  <img src="@/assets/create-new.svg" class="mr-2" alt />Create
                  New
                </b-button>
              </router-link>
            </b-col>
          </b-row>
          <b-row>
            <br />
          </b-row>
          <section v-if="errored">
            <p>
              We're sorry, we're not able to retrieve this information at the
              moment, please try back later
            </p>
          </section>
          <!-- Main table element -->
          <b-table
            v-else
            show-empty
            hover
            ref="selectableTable"
            selectable
            :select-mode="selectMode"
            @row-selected="onRowSelected"
            responsive="sm"
            stacked="md"
            :busy="loading"
            :items="getInfo"
            :fields="key"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
            head-variant="light"
            class="bg-white"
          >
            <div slot="table-busy" class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <template v-slot:head(selected)="data">
              <span class="text-info">
                <b-form-checkbox
                  v-model="allSelected"
                  :indeterminate="indeterminate"
                  aria-describedby="items"
                  aria-controls="items"
                  @change="toggleAll"
                ></b-form-checkbox>
              </span>
            </template>
            <template v-slot:cell(selected)="{ rowSelected, item, index }">
              <template v-if="rowSelected">
                <span aria-hidden="true">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="selected_field_true"
                    name="checkbox-1"
                    value="true"
                    class="pointer-off"
                    unchecked-value="false"
                  ></b-form-checkbox>
                </span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="selected_field_false"
                    name="checkbox-1"
                    value="true"
                    class="pointer-off"
                    unchecked-value="false"
                  ></b-form-checkbox>
                </span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>
            <template v-slot:cell(created_at_date_only)="{ value, item }">
              <p class="mb-0">{{ item.created_at_date_only }}</p>
              by {{ item.created_by_username }}
            </template>
            <template v-slot:cell(updated_at_date_only)="{ value, item }">
              <div v-if="item.updated_at_date_only == ''">-</div>
              <div v-else>
                <p class="mb-0">{{ item.updated_at_date_only }}</p>
                by {{ item.updated_by_username }}
              </div>
            </template>
            <template v-slot:cell(status)="row">
              <p class="text-success" v-if="row.value == 'publish'">Publish</p>
              <p class="text-warning" v-else-if="row.value == 'archive'">
                Archive
              </p>
            </template>
            <template v-slot:cell(image_url)="row">
              <b-img :src="row.value" width="70px" rounded alt="Image"></b-img>
            </template>
            <template v-slot:cell(type)="row">
              <label>{{ row.value }}</label>
            </template>
            <template v-slot:cell(membership_types)="row">
              <label v-if="row.value.length > 1">All Type</label>
              <label class="text-capitalize" v-else>{{ row.value[0] }}</label>
            </template>
            <template v-slot:cell(titles.id)="row">
              <label class="text-primary font-weight-bold">{{
                row.value
              }}</label>
            </template>
            <template v-slot:cell(action)="{ value, item }">
              <b-row>
                <b-col>
                  <b-link v-b-tooltip.hover class="text-danger" @click="del(item.id)" style="text-decoration: none">
                    Delete
                  </b-link>
                </b-col>
                <b-col>
                  <router-link
                    v-b-tooltip.hover
                    title="Edit"
                    :to="{ name: 'editPointSales', params: { id: item } }"
                    class="text-primary"
                    style="text-decoration: none"
                  >
                    Edit
                  </router-link>
                </b-col>
                <b-col>
                  <b-form-checkbox
                    switch
                    v-model="item.enable"
                    @change="activation(item)"
                  ></b-form-checkbox>
                </b-col>
              </b-row>
              <!-- <b-link v-b-tooltip.hover title="Delete" class="mr-2" @click="del(row.item.id)">
            <img src="@/assets/rectangle.svg" alt />
          </b-link>-->
              <!-- <b-link @click="row.toggleDetails">
            <label class="text-primary" style="cursor:pointer">
              Detail <img src="@/assets/ic-drop-yellow-copy-46.svg" alt />
            </label>
          </b-link> -->
              <!-- <b-button
            size="sm"
            @click="row.toggleDetails"
          >{{ row.detailsShowing ? 'Hide' : 'Show' }} Details</b-button>-->
            </template>
            <!-- <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item.reasons" :key="key">
                <ul>
                  <li>Key : {{ key }}</li>
                  <li>Value : {{ value }}</li>
                </ul>
              </li>
            </ul>
          </b-card>
        </template> -->
          </b-table>

          <b-row class="mx-auto">
            <b-col md="4" class="mx-auto px-0">
              <div v-if="totalRows == 0 || totalRows == null">
                Showing 0 Records
              </div>
              <div v-else>
                Showing {{ fromPage[currentPage - 1] }} to
                {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
              </div>
            </b-col>
            <b-col md="4" class="mx-auto"></b-col>
            <b-col md="4" align="right" class="px-0">
              <b-pagination
                align="right"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      loading: false,
      errored: false,
      membership_type: "",
      items: [],
      vuex: [],
      selected: [],
      key: [
        {
          key: "selected",
          class: "text-center",
        },
        {
          key: "benefit_code",
          label: "Benefit Code",
          sortable: true,
          class: "text-center",
        },
        {
          key: "membership_types",
          label: "Membership Type",
          sortable: true,
          class: "text-center",
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
          class: "text-center",
        },
        {
          key: "titles.id",
          label: "Title",
          sortable: true,
          class: "text-left",
        },
        {
          key: "image_url",
          label: "Image",
          sortable: true,
          class: "text-left",
        },
        { key: "action", label: "", class: "text-center w-10" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      title: "",
      fromPage: "",
      toPage: "",
      posm_type: "",
      created_at_start: "",
      created_at_end: "",
      valid_until_start: "",
      valid_until_end: "",
      selectMode: "multi",
      customerShow: false,
      selected_field_true: true,
      selected_field_false: false,
      allSelected: false,
      indeterminate: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    filterPOSM() {
      return this.day_preferenceList.filter((day_pick) => day_pick.is_selected);
    },
  },
  methods: {
    search() {
      this.$refs.selectableTable.refresh();
    },
    resetDateCreatedStart() {
      this.created_at_start = "";
    },
    resetDateCreatedEnd() {
      this.created_at_end = "";
    },
    resetDateValidStart() {
      this.valid_until_start = "";
    },
    resetDateValidEnd() {
      this.valid_until_end = "";
    },
    resetSearch() {
      this.$refs.selectableTable.refresh();
      this.membership_type = "";
      this.posm_type = "";
      this.title = "";
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("title", this.title);
      formData.append("membership_type", this.membership_type);
      formData.append("benefit_type", this.posm_type);
      this.$store
        .dispatch("PointSalesModule/getPointOfSales", formData)
        .then((response) => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.items = response.data.data.benefits || [];
          callback(response.data.data.benefits || []);
          this.loading = false;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading = false;
          callback([]);
        });
      return null;
    },
    ReasonFilter(payload) {
      this.loading = true;
      this.$store
        .dispatch("RatingModule/getReasons", payload)
        .then((response) => {
          this.loading = false;
          this.$swal({
            type: "success",
            title: "Data Filtered",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.serverError = error.response.data;
          console.log(error);
        });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    submitStatus(status) {
      const formData = new FormData();
      $.each(this.selected, (key, value) => {
        formData.append("reason_id", value.id);
        formData.append("status", status);
      });
      $.each(formData.getAll("reason_id"), (key, value) => {
        console.log(value);
      });
      this.loading = true;
      const payload = "fm,lm,shipment";
      this.$store
        .dispatch("RatingModule/updateReasons", formData)
        .then((response) => {
          this.loading = false;
          this.$store.dispatch("RatingModule/getReasons", payload);
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1000,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = error.response;
          console.log(error);
        });
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("PointSalesModule/deletePointOfSales", id);
          this.$refs.selectableTable.refresh();
          this.$swal("Deleted!", "Your data has been deleted.", "success");
        }
      });
    },
    activation(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You will change status Tools!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          const formData = new FormData();
          formData.append("enable", item.enable);
          const payload = {
            id: item.id,
            data: formData,
          };
          this.$store
            .dispatch("PointSalesModule/postActivation", payload)
            .then((response) => {
              console.log(response);
              this.loading = false;
              this.$refs.selectableTable.refresh();
            })
            .catch((error) => {
              this.loading = false;
              this.$refs.selectableTable.refresh();
              console.log(error);
            });
        } else {
          item.enable = !item.enable;
        }
      });
    },
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal) {
        if (newVal.length === 0) {
          this.indeterminate = false;
          this.allSelected = false;
        } else if (newVal.length === this.items.length) {
          this.indeterminate = false;
          this.allSelected = true;
        } else {
          this.indeterminate = true;
          this.allSelected = false;
        }
      }
    },
  },
};
</script>

<style>
</style>
